module.exports = __webpack_public_path__ + "img/LOGO-HORIZONTAL-MARTÍNEZ.8173647c.svg";